
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { KanbanColumn } from "@/components/solar/kanban/types";

interface CardStatusFieldsProps {
  status: string;
  prioridade: string;
  columns: KanbanColumn[];
  onStatusChange: (value: string) => void;
  onPriorityChange: (value: string) => void;
}

export const CardStatusFields = ({ 
  status, 
  prioridade, 
  columns, 
  onStatusChange, 
  onPriorityChange 
}: CardStatusFieldsProps) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="grid gap-2">
        <Label htmlFor="status">Status</Label>
        <Select 
          value={status} 
          onValueChange={onStatusChange}
        >
          <SelectTrigger id="status" className="transition-all duration-200">
            <SelectValue placeholder="Selecione um status" />
          </SelectTrigger>
          <SelectContent>
            {columns.length > 0 ? (
              columns.map((column) => (
                <SelectItem key={column.id} value={column.id}>
                  {column.titulo}
                </SelectItem>
              ))
            ) : (
              <>
                <SelectItem value="lead">Lead</SelectItem>
                <SelectItem value="contato">Em Contato</SelectItem>
                <SelectItem value="proposta">Proposta Enviada</SelectItem>
                <SelectItem value="negociacao">Em Negociação</SelectItem>
                <SelectItem value="fechado">Fechado</SelectItem>
                <SelectItem value="perdido">Perdido</SelectItem>
              </>
            )}
          </SelectContent>
        </Select>
      </div>
      
      <div className="grid gap-2">
        <Label htmlFor="priority">Prioridade</Label>
        <Select 
          value={prioridade} 
          onValueChange={onPriorityChange}
        >
          <SelectTrigger id="priority" className="transition-all duration-200">
            <SelectValue placeholder="Selecione a prioridade" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="baixa">Baixa</SelectItem>
            <SelectItem value="media">Média</SelectItem>
            <SelectItem value="alta">Alta</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
